import { BetActionErrorResponseDataDto } from 'api/common.generated';
import { TFunction } from 'react-i18next';

export function formatBetErrorEvents(data: BetActionErrorResponseDataDto[], t: TFunction): string[] {
	const codes = data.map((item: any) => item.betSlipErrorCode);
	const uniqueCodes = codes.filter((code, index) => codes.indexOf(code) === index);
	return uniqueCodes.map((code) => {
		return `${code} - ${t(`error${code}`)}`;
	});
}
